<template>
  <div class="month-day-group d-inline-flex align-items-center border-bottom gap-1">
    <select class="form-control sm border-0 day-select pr-0"
            :value="selectedDay"
            @change="onDayChange">
      <option value="">-</option>
      <option v-for="d in days"
              :key="d"
              :value="d">
        {{ d }}
      </option>
    </select>
    <select class="form-control sm border-0 pl-0 month-select"
            :value="selectedMonth"
            @change="onMonthChange">
      <option value="">-</option>
      <option v-for="m in months"
              :key="m.value"
              :value="m.value">
        {{ m.label }}
      </option>
    </select>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import i18n from '@/lang/i18n'

const props = defineProps({
  value: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['input'])

const t = (key) => i18n.global.t(key)

const selectedMonth = computed(() => props.value?.split('-')[0] || '')
const selectedDay = computed(() => props.value?.split('-')[1] || '')

const months = computed(() => {
  const keys = ['january','february','march','april','may','june','july','august','september','october','november','december']
  return keys.map((key, i) => ({
    value: String(i + 1).padStart(2, '0'),
    label: t(key)
  }))
})

const days = computed(() => {
  const count = selectedMonth.value ? daysInMonth(parseInt(selectedMonth.value)) : 31
  return Array.from({ length: count }, (_, i) => String(i + 1).padStart(2, '0'))
})

function daysInMonth(month) {
  const longMonths = [1, 3, 5, 7, 8, 10, 12]
  if (longMonths.includes(month)) return 31
  if (month === 2) return 29
  return 30
}

function emitValue(month, day) {
  if(month && !day) day = '01'
  if(day && !month) month = '01'
  emit('input', month && day ? `${month}-${day}` : null)
}

function onMonthChange(e) {
  const month = e.target.value
  let day = selectedDay.value
  if (day && month) {
    const maxDays = daysInMonth(parseInt(month))
    if (parseInt(day) > maxDays) day = String(maxDays).padStart(2, '0')
  }
  emitValue(month, day)
}

function onDayChange(e) {
  emitValue(selectedMonth.value, e.target.value)
}
</script>

<style scoped lang="scss">
.month-day-group {
  .month-select {
    min-width: 110px;
  }
  .day-select {
    min-width: 60px;
  }
}
</style>
